module.exports = __webpack_public_path__ + "static/media/slider_4.697accd1.webp";